import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

// Use original logo with background for dark footer
const LOGO_URL = "https://customer-assets.emergentagent.com/job_eurocar-start/artifacts/8uumeb1a_eurocars-logo.png";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="mb-4">
              <img 
                src={LOGO_URL} 
                alt="Euro Cars" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="font-dm-sans text-slate-400 text-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-outfit font-semibold text-base mb-4">{t("footer.quickLinks")}</h4>
            <div className="space-y-3">
              {[
                { to: "/", label: t("nav.home") },
                { to: "/fleet", label: t("nav.fleet") },
                { to: "/about", label: t("nav.about") },
                { to: "/contact", label: t("nav.contact") },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block font-dm-sans text-sm text-slate-400 hover:text-orange-400 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-outfit font-semibold text-base mb-4">{t("footer.contactInfo")}</h4>
            <div className="space-y-3 font-dm-sans text-sm text-slate-400">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" />
                <span>{t("contact.info.address")}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-orange-400 shrink-0" />
                <a href="tel:+306909086661" className="hover:text-white transition-colors">{t("contact.info.phone")}</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-orange-400 shrink-0" />
                <a href="mailto:info@eurocars-rent.gr" className="hover:text-white transition-colors">{t("contact.info.email")}</a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-outfit font-semibold text-base mb-4">{t("footer.hours")}</h4>
            <div className="space-y-3 font-dm-sans text-sm text-slate-400">
              <div className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" />
                <div>
                  <p>{t("footer.monFri")}</p>
                  <p>{t("footer.satSun")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-dm-sans text-sm text-slate-500">
            &copy; {new Date().getFullYear()} Euro Cars Rent. {t("footer.rights")}
          </p>
          <Link to="/admin/login" className="font-dm-sans text-xs text-slate-600 hover:text-slate-400 transition-colors">
            {t("nav.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
